const DEFAULT_POSITION = { x: 0, y: 0 }
const DEFAULT_MOVE_THRESHOLD = 80 // least pixels movement to action.

export { DEFAULT_POSITION, DEFAULT_MOVE_THRESHOLD }
